//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "PropertyNSFPaymentSettings",
    data: function data() {
        return {
            modalName: 'nsf-payment-settings',
            chargeCodes: [],
            chargeCode: { id: 0, name: 'Select Code' },
            noRestrictions: false,
            data: {
                accounting_charge_code_id: 0,
                no_online_payments_cap: 0,
                no_online_payments_restore_months: 0,
                no_checks_accepted_cap: 0,
                no_checks_accepted_restore_months: 0
            },
            validations: [{ model: 'data.accounting_charge_code_id', rules: 'required | integer | min:1' }, { model: 'data.no_online_payments_cap', rules: 'required | integer | min:0' }, { model: 'data.no_online_payments_restore_months', rules: 'required | integer | min:0' }, { model: 'data.no_checks_accepted_cap', rules: 'required | integer | min:0' }, { model: 'data.no_checks_accepted_restore_months', rules: 'required | integer | min:0' }]
        };
    },
    mounted: function mounted() {
        var _this = this;

        Event.$on('property-settings-nsf-payments', function () {
            var self = _this;

            Event.$emit('open-slide', _this.modalName);
            _this.load();

            axios.post('/prototype/accounting/charge-codes/categories', { parent: 'ar' }).then(function (response) {
                _this.categories = response.data;
                if (_this.categories.length > 0) {
                    var matchedCategory = false;
                    _this.categories.forEach(function (cat) {
                        if (cat.name === "Miscellaneous Charges") {
                            // i don't really know how to get around this
                            matchedCategory = cat;
                        }
                    });
                    axios.post('/prototype/accounting/charge-codes/codes', { id: matchedCategory.id }).then(function (response) {
                        _this.chargeCodes = response.data;
                        _this.chargeCode = _this.chargeCodes.find(function (chargeCode) {
                            return self.data && chargeCode.id === self.data.accounting_charge_code_id;
                        });
                    });
                }
            });
        });

        Event.$on('close-slide', function () {
            _this.editing = false;
        });
    },

    methods: {
        load: function load() {
            var self = this;

            axios.get('/prototype/property/nsf-payment-settings').then(function (response) {
                if (response.data) {
                    self.data = response.data.n_s_f_payment_settings || self.data;

                    if (self.data && !self.data.no_online_payments_cap && !self.data.no_online_payments_restore_months && !self.data.no_checks_accepted_cap && !self.data.no_checks_accepted_restore_months) {
                        self.noRestrictions = true;
                    }
                }
            });
        },
        cancel: function cancel() {
            Event.$emit('close-slide', this.modalName);
        },
        save: function save() {
            var _this2 = this;

            this.$initValidator();
            this.validator.setRules(this.validations).validate();

            if (this.validator.fails()) {
                var errors = [];
                errors = this.validator.errorsBag;
                var msg = '';
                errors.forEach(function (error) {
                    msg += error.message + '(' + error.model + ')' + '.';
                });
                this.$snotify.error(msg);
            }

            if (this.noRestrictions) {
                this.data.no_online_payments_cap = 0;
                this.data.no_online_payments_restore_months = 0;
                this.data.no_checks_accepted_cap = 0;
                this.data.no_checks_accepted_restore_months = 0;
            }

            axios.post('/prototype/property/nsf-payment-settings', this.data).then(function (response) {
                _this2.data = response.data;
            }).then(function (response) {
                Event.$emit('close-slide', _this2.modalName);
            }).then(function (response) {
                _this2.$snotify.success("Changes saved successfully.");
            });
        },
        chargeCodeSelect: function chargeCodeSelect() {
            if (typeof this.chargeCode !== "undefined" && this.chargeCode.id !== 0) {
                this.data.accounting_charge_code_id = this.chargeCode.id;
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/settings/PropertySettingsNSFPayments.vue
// module id = ocz2
// module chunks = 0 1